import { render, staticRenderFns } from "./FolderNode.vue?vue&type=template&id=7037f6d3&scoped=true&"
import script from "./FolderNode.vue?vue&type=script&lang=js&"
export * from "./FolderNode.vue?vue&type=script&lang=js&"
import style0 from "./FolderNode.vue?vue&type=style&index=0&id=7037f6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037f6d3",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/folder/FolderNode.vue"
export default component.exports